import { selectSerializer } from 'libs/serializers';
import useFetchResource from '../useFetchResource';
import api from 'libs/api';

export function useRegions(
  initialLoad = false,
  serializerConfig = { labelKey: 'title', valueKey: 'short_code' }
) {
  const { resource: regions, fetchResource: fetchRegions } = useFetchResource({
    api: api.location.getRegions,
    initialValues: [],
    initialLoad,
    serializer: (data) => selectSerializer(data.resources, serializerConfig),
  });
  return { regions, fetchRegions };
}
